import type { CustomFieldDto, CustomValues } from '@performance-crm/shared';

/** Valores del formulario (siempre texto) a partir de los guardados en el lead. */
export function customFormValues(
  fields: CustomFieldDto[],
  current: CustomValues | undefined,
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const f of fields) {
    const v = current?.[f.key];
    out[f.key] =
      v === null || v === undefined ? '' : f.type === 'SI_NO' ? String(v === true) : String(v);
  }
  return out;
}

/**
 * Del formulario a lo que entiende la API: vacío = null (borra), Sí / No como booleano, números como número.
 * Con `omitEmpty` (Nuevo lead, G1) un campo vacío no se manda: un recontacto nunca borra lo que el lead ya tenía.
 */
export function customPayload(
  fields: CustomFieldDto[],
  values: Record<string, string>,
  opts: { omitEmpty?: boolean } = {},
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const f of fields) {
    const raw = (values[f.key] ?? '').trim();
    if (raw === '') {
      if (!opts.omitEmpty) out[f.key] = null;
    } else if (f.type === 'SI_NO') out[f.key] = raw === 'true';
    else if (f.type === 'NUMERO') out[f.key] = raw;
    else out[f.key] = raw;
  }
  return out;
}

/** Campos obligatorios sin valor (solo en los formularios de la web). */
export function customFormErrors(
  fields: CustomFieldDto[],
  values: Record<string, string>,
): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const f of fields)
    if (f.required && !(values[f.key] ?? '').trim()) errors[f.key] = `${f.label} es obligatorio`;
  return errors;
}
